import clsx from "clsx";
import { CompareScalarRow } from "./@types";
import styles from "./compare-samples.module.scss";

interface ScalarRowProps {
  row: CompareScalarRow;
}

const ScalarRow = ({ row }: ScalarRowProps): JSX.Element => {
  const valueClass = clsx(styles.value, {
    [styles["value--mono"]]: row.isMonospace,
    [styles["value--same"]]: !row.differs
  });

  return (
    <div
      className={clsx(styles.row, {
        [styles["row--differs"]]: row.differs
      })}
    >
      <div className={styles.label}>
        <span
          className={clsx(styles.marker, {
            [styles["marker--differs"]]: row.differs
          })}
        />
        {row.label}
      </div>
      <div className={valueClass}>{row.main}</div>
      <div className={valueClass}>{row.other}</div>
    </div>
  );
};

export default ScalarRow;
